"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = _interopRequireDefault(require("@ux/button"));
var _spinner = _interopRequireDefault(require("@ux/spinner"));
var _util = require("@ux/util");
var _reactMintl = require("@godaddy/react-mintl");
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Render and expose the email subscription form as a functional Component.
 *
 * @param {Object} props Properties
 * @public
 */
class EmailForm extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      signUpResult: false,
      signingUp: false,
      errorMessage: false
    };
    this.submitEmailForm = this.submitEmailForm.bind(this);
    this.signupUser = this.signupUser.bind(this);
  }

  /**
   * Attempts to submit the email for for the user.
   * @param  {Event} evt React Synthetic event for Form Submission .
   */
  submitEmailForm(evt) {
    evt.preventDefault();
    const env = this.props.env;
    const destination = new _util.URL(`https://gui.${env !== 'prod' ? env + '-' : ''}godaddy.com/v1/subscription/subscribe`);
    this.signupUser(destination.href);
  }

  /**
   * Signs user email up for a subscription
   *
   * @param {Location|String} url New url
   * @private
   */
  signupUser(url) {
    const addrHolder = this.emailInput.value;
    let errCode = 0;
    if (!/.+@.+\..{2,}/.test(addrHolder)) {
      errCode = 'PC:Javascript:EnterValidEmail';
    } else if (addrHolder.length > 100) {
      errCode = 'PC:Javascript:EmailAddressTooLong';
    }
    if (errCode) {
      this.setState({
        errorMessage: errCode,
        signUpResult: 'delete-fill'
      });
      return;
    }
    const body = JSON.stringify({
      EmailAddress: addrHolder,
      PublicationId: 0,
      TemplateInfo: {
        TemplateTypeKey: 'GDWelcomeConfirmationSB',
        TemplateNamespaceKey: 'GDSHOP'
      }
    });
    this.setState({
      signingUp: true
    });
    _util.request.post(url, body, err => {
      this.emailInput.value = '';
      this.setState({
        signingUp: false,
        signUpResult: err ? 'delete-fill' : 'ok',
        errorMessage: err ? 'Sales:Footer:SpecialOfferForm:SignUpError' : 'Sales:Footer:SpecialOfferForm:SignUpSuccess'
      });
    });
  }
  /* eslint-disable-next-line max-statements */
  render() {
    const {
      signUpResult,
      signingUp,
      errorMessage
    } = this.state;
    const props = this.props;
    const {
      seechange
    } = props;
    let submitMessage;
    const submitMessageProps = {
      id: seechange ? 'Sales:Footer:SpecialOfferForm:SignUp' : 'Sales:Footer:SpecialOfferForm:SubmitButton'
    };
    const emailClasses = [];
    const errorState = ['email-message'];
    let buttonColor = 'primary';
    let buttonBackgroundClass = '';
    if (signingUp) {
      submitMessage = /*#__PURE__*/_react.default.createElement(_spinner.default, {
        size: "sm",
        shade: "light"
      });
    } else if (signUpResult) {
      if (signUpResult === 'delete-fill') {
        // TO DO: This should be changed to 'critical' once uxcore2@2001 is eol
        buttonColor = 'primary';
        buttonBackgroundClass = 'error-background';
        emailClasses.push('email-error');
        errorState.push('email-error');
      } else {
        submitMessageProps.id = 'PC:Javascript:ThankYou';
      }
    }
    const placeholder = props.messages['Sales:Footer:SpecialOfferForm:EmailPlaceholder'];
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "newsletter-form"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "specialOfferForm"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: seechange ? 'Sales:Footer:SpecialOfferForm:Label' : 'Sales:Footer:SpecialOfferForm:Heading'
    })), /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this.submitEmailForm
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "newsletter-signup"
    }, /*#__PURE__*/_react.default.createElement("input", {
      id: "specialOfferForm",
      className: (0, _classnames.default)(...emailClasses),
      placeholder: placeholder,
      ref: r => this.emailInput = r,
      onChange: () => {
        if (signUpResult) this.setState({
          signUpResult: null,
          errorMessage: null
        });
      }
    }), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, submitMessageProps, content => /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "submit",
      design: buttonColor,
      className: buttonBackgroundClass,
      onClick: this.submitEmailForm,
      text: submitMessage || content
    }))), errorMessage && /*#__PURE__*/_react.default.createElement("p", {
      "aria-live": "polite",
      className: (0, _classnames.default)(...errorState)
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: errorMessage
    }))));
  }
}
EmailForm.propTypes = {
  messages: _propTypes.default.object.isRequired,
  env: _propTypes.default.string.isRequired,
  seechange: _propTypes.default.bool
};
EmailForm.defaultProps = {
  seechange: false
};
var _default = EmailForm;
exports.default = _default;